import {Navbar,Nav,Container} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './nav.css';
import {Button} from '@mui/material';
const Navb=()=>{
    return(
        <>
              <Navbar expand="lg" className="bg-body-tertiary sticky-top shadow-lg about-box">
                <Container>
                    <Navbar.Brand id='welcome'>Welcome</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto" >
                    <a herf='#home' className='nav-Ex-text ' style={{color:"#f82882"}}>Home</a>
                    <a herf='#about' className='nav-Ex-text '>About</a>
                    <a herf='#resume' className='nav-Ex-text '>Resume</a>
                    <a herf='#award' className='nav-Ex-text '>Award</a>
                    <a href="#contact" className='nav-Ex-text '>Contact</a>
                    &nbsp;
                    <NavLink to='/FreePro'><Button variant='contained'><i class="fa-solid fa-diagram-project"></i>&nbsp; Free Project</Button></NavLink>
                    </Nav>
                    </Navbar.Collapse>
                </Container>
                </Navbar>
        </>
    )
}
export default Navb;